/**
 * Form Actions Constants
 * Standard actions for form workflow tracking lifecycle
 */

export const FORM_ACTIONS = {
  /** Form has been initialized/loaded */
  INITIATED: "initiated",
  /** Form has been submitted by user */
  SUBMITTED: "submitted",
  /** Form processing completed successfully */
  COMPLETED: "completed",
  /** Form encountered an error */
  ERROR: "error",
  /** Form step change (for multi-step forms) */
  STEP: "step",
} as const;

export type FormActionType = (typeof FORM_ACTIONS)[keyof typeof FORM_ACTIONS];
